import React from 'react';
import styles from './styles.module.css';

const List = ({ text }) => {
  return (
    <>
      {text.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </>
  );
};

const Skills = ({ skills }) => (
  <>
    <div className={styles.root}>
      <div className={styles.flex}>
        <img
          alt={'иконка раздела «Чему я научусь:»'}
          src="https://images.ctfassets.net/67gkhzpoimdx/5UmaE6YcwOsrSpMGOk2CI7/fe4e44e55cf4c51d120d73603ac9ac1b/skills.svg"
          className={styles.icon}
        />
        <span className={styles.title}>Чему я научусь</span>
      </div>
      <ul className={styles.list}>
        {skills.map((item, i) => (
          <List key={i} text={item.text} />
        ))}
      </ul>
    </div>
  </>
);

export default Skills;
